export default __webpack_public_path__ + "static/media/financeReportsActive.9f573181.svg";